export const DictionaryLoadingSkeleton = () => {
  return (
    <div className="space-y-8">
      {[1, 2, 3].map((section) => (
        <section key={section} className="animate-pulse">
          <div className="py-2 mb-4">
            <div className="w-12 h-12 rounded-xl bg-muted" />
          </div>
          <div className="grid gap-4">
            {[1, 2, 3].map((item) => (
              <div
                key={item}
                className="p-6 rounded-2xl bg-card border border-border"
              >
                <div className="w-24 h-5 bg-muted rounded-full mb-3" />
                <div className="w-48 h-6 bg-muted rounded mb-3" />
                <div className="space-y-2">
                  <div className="w-full h-4 bg-muted rounded" />
                  <div className="w-3/4 h-4 bg-muted rounded" />
                </div>
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};
